import React from 'react';
import './AppLoading.css';
import Bo from '../Bo/Bo';
import BrandLogo from '../BrandLogo/BrandLogo';

// Giao diện màn hình tải, không có state hay hook dữ liệu: lúc build scripts/inline-app-loading.js vẽ sẵn
// component này vào HTML để trình duyệt vẽ ngay khi tải xong HTML, không phải chờ JS/CSS/font.
// Lúc dev (npm start) HTML chưa có bản vẽ sẵn thì AppLoading tự render component này.
// Mặt Bo đổi theo nhịp bằng CSS (AppLoading.css), vì bản vẽ sẵn không có React để đổi mood.

const INK = '#5A0E16';
// Tia sáng hình quạt quanh đồng xu lúc xu vào khe (độ, 0 = thẳng lên)
const RAY_ANGLES = [-60, -30, 0, 30, 60];
// Lấp lánh quanh đầu Bo: [cx, cy, r] theo viewBox 300 của Bo
const SPARKLES = [[44, 40, 10], [258, 28, 13], [206, -6, 8]];
// Vui vẻ lúc nói → cười tít mắt khi bật nhảy → nháy mắt khi đáp đất
const BO_FACES = ['happy', 'laugh', 'wink'];

const sparklePath = (cx, cy, r) => {
  const k = r * 0.25;
  return `M${cx} ${cy - r} Q${cx + k} ${cy - k} ${cx + r} ${cy} Q${cx + k} ${cy + k} ${cx} ${cy + r} Q${cx - k} ${cy + k} ${cx - r} ${cy} Q${cx - k} ${cy - k} ${cx} ${cy - r} Z`;
};

// prerendered: bản vẽ sẵn lúc build, lần vẽ đầu chỉ có nền và chữ font hệ thống (.is-prerendered trong AppLoading.css)
const AppLoadingView = ({ isExiting = false, prerendered = false }) => (
  <div
    id="app-loading"
    className={`app-loading${prerendered ? ' is-prerendered' : ''}${isExiting ? ' is-exiting' : ''}`}
    role="status"
    aria-live="polite"
    aria-label="Đang tải CaskBack"
  >
    <div className="app-loading__content">
      <span className="app-loading__logo-wrap">
        <BrandLogo className="app-loading__logo" shine />
      </span>
      {/* Bo đứng trái, câu thông điệp là bong bóng thoại của Bo bên phải */}
      <div className="app-loading__stage">
        <div className="app-loading__bo-wrap" aria-hidden="true">
          <Bo className="app-loading__bo" faces={BO_FACES} pose="none" size={150} />
          {/* Lớp hiệu ứng chồng khít lên Bo, cùng viewBox 300 nên dùng chung toạ độ với Bo.js */}
          <svg className="app-loading__fx" viewBox="0 0 300 300" focusable="false">
            {RAY_ANGLES.map((a) => (
              <g key={a} transform={`rotate(${a} 150 62)`}>
                <path className="app-loading__ray" d="M150 30 L150 18" fill="none" stroke={INK} strokeWidth="4.5" strokeLinecap="round" />
              </g>
            ))}
            {SPARKLES.map(([cx, cy, r], i) => (
              <path
                key={`${cx}-${cy}`}
                className={`app-loading__sparkle app-loading__sparkle--${i + 1}`}
                d={sparklePath(cx, cy, r)}
                fill="#FFC53D"
                stroke={INK}
                strokeWidth="3"
                strokeLinejoin="round"
              />
            ))}
            {/* Đồng xu vẽ giống hệt xu trong khe của Bo: rơi tới đúng chỗ rồi nhường cho xu trong khe */}
            <g className="app-loading__coin">
              <g className="app-loading__coin-spin">
                <circle cx="150" cy="62" r="24" fill="#FFC53D" stroke={INK} strokeWidth="4.5" />
                <circle cx="150" cy="62" r="16" fill="none" stroke="#F59F00" strokeWidth="3" />
                <path d="M137 57 Q140 47 150 44" fill="none" stroke="#FFF3C4" strokeWidth="4" strokeLinecap="round" />
                <text x="151" y="71" textAnchor="middle" fontSize="24" fontWeight="800" fill="#A85A00" fontFamily="'Baloo 2', 'Be Vietnam Pro', sans-serif">đ</text>
              </g>
            </g>
          </svg>
        </div>
        <p className="app-loading__say bo-say">
          <span className="app-loading__say-line">Đổi link,</span>
          <span className="app-loading__say-line app-loading__say-line--2">
            rinh <em className="app-loading__say-hit">hoàn tiền.</em>
          </span>
        </p>
      </div>
      <div className="app-loading__bar" aria-hidden="true">
        <span className="app-loading__bar-fill" />
      </div>
    </div>
    <p className="app-loading__footer">Tiện ích mua sắm hoàn tiền, tổng hợp deal hot nhất</p>
  </div>
);

export default AppLoadingView;
